/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { CutQueuedOutDeferredReasonCode } from './cutQueuedOutDeferredReasonCode';

export interface CutQueuedOut {
  queued: boolean;
  cut_request_id: string | null;
  cut_workflow_id: string | null;
  deferred_reason_code: CutQueuedOutDeferredReasonCode;
}
